import { css } from '@emotion/react';
import React from 'react';

import { BookingBreakdownCard } from '@/booking/components';
import { BookingRequest } from '@/booking/interfaces';
import { useTranslation } from '@/i18n';

interface BookingComparisonProps {
  oldBooking: BookingRequest;
  newBooking: BookingRequest;
}

export const BookingComparison: React.FC<BookingComparisonProps> = (props) => {
  const { t } = useTranslation('bookingManagement');

  return (
    <div css={wrapperStyle}>
      <div>
        <BookingBreakdownCard
          {...props.oldBooking}
          cardLabel={t('comparison.existingBooking')}
        />
      </div>
      <div css={spacerStyle}></div>
      <div>
        <BookingBreakdownCard
          {...props.newBooking}
          cardLabel={t('comparison.newBooking')}
        />
      </div>
    </div>
  );
};

const wrapperStyle = css`
  display: flex;

  > div {
    /* width: 50%; */
    flex: 1;
  }

  @media all and (max-width: 700px) {
    display: block;
  }
`;

const spacerStyle = css`
  max-width: 40px;

  @media all and (max-width: 700px) {
    height: 24px;
  }
`;
